import {useTranslation} from "react-i18next";
import { useEffect, useState } from "react";
import SymptomsTable from "../symptoms/SymptomsTable";
import {Consts} from "../pages/consts";
import {getPatientName} from "../pages/utils";
import useDialogDrag from "../../hooks/useDialogDrag";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

const PatientSymptoms = ({
                           showDialog,
                           onCloseDialog,
                           patient,
                           disabledSeeNames
                         }) => {
  const {t} = useTranslation();
  const { dragStyle, isDragging, onDragHandleMouseDown } = useDialogDrag(showDialog);
  const [editorGroupKey, setEditorGroupKey] = useState(null);

  useEffect(() => {
    if (!showDialog) {
      setEditorGroupKey(null);
    }
  }, [showDialog]);

  const dialogTitle = editorGroupKey
    ? t(editorGroupKey)
    : `${t("symptoms_of_patient")} ${getPatientName(patient, disabledSeeNames)}`;

  return (
    <div className="w3-modal" style={ {display: showDialog ? Consts.BLOCK : Consts.NONE} }>
      <div
        className={`w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 dialog-medium dialog-draggable ${isDragging ? "dialog-draggable--dragging" : ""}`}
        style={dragStyle}
      >
        <header className="dialog-drag-header" onMouseDown={onDragHandleMouseDown}>
          <strong className="dialog-drag-header__title">{dialogTitle}</strong>
          <button
            type="button"
            className="dialog-drag-close"
            onClick={onCloseDialog}
            aria-label={t("close", { defaultValue: "Close" })}
            title={t("close", { defaultValue: "Close" })}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </header>
        <SymptomsTable
          selectedPatient={ patient }
          hcpView={ true }
          chartActionInToolbar={true}
          onDialogTitleKeyChange={setEditorGroupKey}
        />
      </div>
    </div>
  );
};

export default PatientSymptoms;
